module.exports = __webpack_public_path__ + "static/img/rule.eedb858.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/match/rule.png
// module id = uunW
// module chunks = 0